import { createSelector } from "reselect";
import { ApplicationStore } from "src/store";
import { ConditionalRebate } from "Types/state";

export const getConditionalRebatesType = (state: ApplicationStore) =>
    state.account?.integration_settings?.Financing?.conditional_rebates ?? "none";

export const isConditionalRebatesEnabled = (state: ApplicationStore) =>
    (state.account?.integration_settings?.Financing?.conditional_rebates ?? "none") !== "none";

export const isConditionalRebatesDataDriven = (state: ApplicationStore) =>
    (state.account?.integration_settings?.Financing?.conditional_rebates ?? "none") === "data-driven";

/**
 * added this selector per https://dealerinspire.atlassian.net/browse/ONSHOP-7354
 * the goal is to grab the conditional rebates by vin, and if the array contains
 * ID: 4, move it to front of array, so it is displayed first since it is the only
 * currently pre-selected rebate...this should be a temporary fix
 */
export const availableConditionalRebatesByVinSorted = createSelector(
    (state: ApplicationStore) => state.conditionalRebates.dataDriven.available ?? [],
    (state: ApplicationStore, vin: string) => vin,
    (available, vin) =>
        available[vin]?.reduce((acc: ConditionalRebate[], rebate: ConditionalRebate) => {
            if (rebate.id === 4) return [rebate, ...acc];
            return [...acc, rebate];
        }, [])
);
